// extracted by mini-css-extract-plugin
export var shake = "_p-0";